// src/custom-field-definition.ts
import { oz as oz5 } from "@vy/oz";
import { IntegrationTypesSchema } from "@vy/integrations-types";
import { ApiDateSchema } from "@vy/date";

// src/custom-field-types/custom-field-entity.ts
import { oz } from "@vy/oz";
var CUSTOM_FIELD_ENTITIES = Object.freeze({
  CUSTOMER: "Customer",
  CONTRACT: "Contract",
  INVOICE: "Invoice",
  LINE_ITEM: "LineItem"
});
var CustomFieldEntitiesSchema = oz.nativeEnum(CUSTOM_FIELD_ENTITIES).openapi("CustomFieldEntities");

// src/custom-field-types/custom-field-value-type.ts
import { oz as oz2 } from "@vy/oz";
var CUSTOM_FIELD_VALUE_TYPES = Object.freeze({
  STRING: "String",
  NUMBER: "Number",
  BOOLEAN: "Boolean",
  ENUM: "Enum"
});
var CustomFieldValueTypesSchema = oz2.nativeEnum(CUSTOM_FIELD_VALUE_TYPES).openapi("CustomFieldValueTypes");

// src/custom-field-types/custom-field-scalar-value.ts
import { oz as oz3 } from "@vy/oz";
var CustomFieldScalarValueSchema = oz3.union([oz3.string(), oz3.number(), oz3.boolean()]);

// src/custom-field-types/integration-entity-type.ts
import { oz as oz4 } from "@vy/oz";
var INTEGRATION_ENTITY_TYPES = Object.freeze({
  ACCOUNT: "Account",
  INVOICE: "Invoice",
  SALES_ORDER: "SalesOrder",
  ITEM: "Item",
  DEAL: "Deal",
  COMPANY: "Company",
  OPPORTUNITY: "Opportunity"
});
var IntegrationEntityTypesSchema = oz4.nativeEnum(INTEGRATION_ENTITY_TYPES).openapi("IntegrationEntityTypes");

// src/custom-field-definition.ts
var CustomFieldDefinitionSchema = oz5.object({
  id: oz5.string(),
  accountId: oz5.string(),
  integrationId: oz5.string().optional(),
  integrationSource: IntegrationTypesSchema.optional(),
  integrationEntityType: IntegrationEntityTypesSchema.optional(),
  fieldPath: oz5.string().optional(),
  vayuEntity: CustomFieldEntitiesSchema,
  vayuCustomFieldName: oz5.string(),
  valueType: CustomFieldValueTypesSchema,
  allowedValues: oz5.string().array().optional(),
  defaultValue: oz5.string().optional(),
  createdAt: ApiDateSchema,
  updatedAt: ApiDateSchema
}).openapi("CustomFieldDefinition");

// src/custom-field-value.ts
import { oz as oz6 } from "@vy/oz";
var CustomFieldValueSchema = oz6.object({
  customFieldDefinitionId: oz6.string(),
  value: CustomFieldScalarValueSchema.nullable().optional(),
  fieldName: oz6.string().optional()
}).openapi("CustomFieldValue");

// src/custom-field-value-with-definition.ts
var CustomFieldValueWithDefinitionSchema = CustomFieldValueSchema.extend({
  definition: CustomFieldDefinitionSchema.optional()
}).openapi("CustomFieldValueWithDefinition");
export {
  CUSTOM_FIELD_ENTITIES,
  CUSTOM_FIELD_VALUE_TYPES,
  CustomFieldDefinitionSchema,
  CustomFieldEntitiesSchema,
  CustomFieldScalarValueSchema,
  CustomFieldValueSchema,
  CustomFieldValueTypesSchema,
  CustomFieldValueWithDefinitionSchema,
  INTEGRATION_ENTITY_TYPES,
  IntegrationEntityTypesSchema
};
